export default "__VITE_ASSET__D59Qs_TB__"